/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateMetaMcpServerForm,
  UpdateMetaMcpServerForm$Outbound,
  UpdateMetaMcpServerForm$outboundSchema,
} from "../components/updatemetamcpserverform.js";

export type UpdateMetaMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateMetaMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateMetaMcpServerSecurity = {
  option1?: UpdateMetaMcpServerSecurityOption1 | undefined;
  option2?: UpdateMetaMcpServerSecurityOption2 | undefined;
};

export type UpdateMetaMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateMetaMcpServerForm: UpdateMetaMcpServerForm;
};

/** @internal */
export type UpdateMetaMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateMetaMcpServerSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateMetaMcpServerSecurityOption1$Outbound,
  UpdateMetaMcpServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateMetaMcpServerSecurityOption1ToJSON(
  updateMetaMcpServerSecurityOption1: UpdateMetaMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    UpdateMetaMcpServerSecurityOption1$outboundSchema.parse(
      updateMetaMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateMetaMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateMetaMcpServerSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateMetaMcpServerSecurityOption2$Outbound,
  UpdateMetaMcpServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateMetaMcpServerSecurityOption2ToJSON(
  updateMetaMcpServerSecurityOption2: UpdateMetaMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    UpdateMetaMcpServerSecurityOption2$outboundSchema.parse(
      updateMetaMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateMetaMcpServerSecurity$Outbound = {
  Option1?: UpdateMetaMcpServerSecurityOption1$Outbound | undefined;
  Option2?: UpdateMetaMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateMetaMcpServerSecurity$outboundSchema: z.ZodMiniType<
  UpdateMetaMcpServerSecurity$Outbound,
  UpdateMetaMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateMetaMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateMetaMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateMetaMcpServerSecurityToJSON(
  updateMetaMcpServerSecurity: UpdateMetaMcpServerSecurity,
): string {
  return JSON.stringify(
    UpdateMetaMcpServerSecurity$outboundSchema.parse(
      updateMetaMcpServerSecurity,
    ),
  );
}

/** @internal */
export type UpdateMetaMcpServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateMetaMcpServerForm: UpdateMetaMcpServerForm$Outbound;
};

/** @internal */
export const UpdateMetaMcpServerRequest$outboundSchema: z.ZodMiniType<
  UpdateMetaMcpServerRequest$Outbound,
  UpdateMetaMcpServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateMetaMcpServerForm: UpdateMetaMcpServerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateMetaMcpServerForm: "UpdateMetaMcpServerForm",
    });
  }),
);

export function updateMetaMcpServerRequestToJSON(
  updateMetaMcpServerRequest: UpdateMetaMcpServerRequest,
): string {
  return JSON.stringify(
    UpdateMetaMcpServerRequest$outboundSchema.parse(updateMetaMcpServerRequest),
  );
}
